import { ofType } from 'redux-observable-es6-compat';
import { map, mergeMap, tap } from 'rxjs/operators';

import { ASetPlayerId, ASetRemote, ASetRemotes, TRemote } from '../actions';
import { sseApi } from '../infra';

export const fetchRemotesEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TRemote.FETCH_REMOTES),
    tap(({ payload }) => localStorage.setItem('resortId', payload)),
    mergeMap(({ payload }) => restApi.get(`/player/resort/${payload}`, 60000)),
    map(ASetRemotes),
  );


export const setRemoteEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TRemote.SET_PLAYER_ID),
    tap(() => sseApi.close()),
    tap(({ payload }) => restApi.setPlayerId(payload.id)),
    tap(({ payload }) => localStorage.setItem('playerId', payload.id)),
    map(({ payload }) => ASetRemote(payload))
  );
